<div *ngIf="medicalBill && medicalBill.totalCharges" class="flex flex-row w-full ">
        <p-card header="Bill Detail" class="flex w-full" [style]="{'width': '100%'}">
            <div class="flex w-full flex-column">
                <div class="flex w-full grid align-items-center">

                    <!-- Discount Portions -->
                    <div class="flex col-3">
                        <p-floatLabel>
                            <p-inputNumber id="confirmedCharges"  [(ngModel)]="medicalBill.totalCharges" mode="currency" currency="USD" locale="en-US"  [disabled]="true" />
                            <label for="confirmedCharges">Total Charges</label>
                        </p-floatLabel>
                    </div>
                    <div class="flex col-1 justify-content-center ">
                        <i class="pi pi-times"></i>
                    </div>
                    <div *ngIf="locked || !medicalBill.overrideDiscount" class="flex col-3 flex-column">
                        <p-floatLabel>
                            <p-inputNumber id="confirmedDiscount"  [(ngModel)]="medicalBill.calculatedDiscountPercent" mode="percent"   [disabled]="true" />
                            <label for="confirmedDiscount">Discount</label>
                        </p-floatLabel>
                    </div>
                    <div *ngIf="medicalBill.overrideDiscount && !locked" class="flex col-3 flex-column">
                        <p-floatLabel>
                            <p-inputNumber id="confirmedDiscount"  [(ngModel)]="overridePercentAmount"  mode="decimal"  suffix="%"  [maxFractionDigits]="2" [minFractionDigits]="2" (onBlur)="manualDiscountChanged();"  />
                            <label for="confirmedDiscount">Discount</label>
                        </p-floatLabel>
                    </div>
                    <div class="flex col-1 ">
                        <i class="pi pi-equals"></i>
                    </div>
                    <div class="flex col-4">
                        <p-floatLabel>
                            <p-inputNumber id="allowedAmount"  [(ngModel)]="medicalBill.confirmedAllowedAmount" mode="currency" currency="USD" locale="en-US"  [disabled]="true" />
                            <label for="allowedAmount">Provider Paid</label>
                        </p-floatLabel>
                    </div>
                    <div class="flex col-4 pb-2"></div>
                    <div class="flex col-3 pb-2">
                        <p-checkbox *ngIf="!locked" [(ngModel)]="medicalBill.overrideDiscount" binary label="Override" (onChange)="billEdited = true; recalculateAllowedAmount();"></p-checkbox>
                    </div>
                    <div class="flex col-5 pb-2"></div>


                    <!-- Markup Portions -->
                    <div class="flex col-3 mt-2">
                        <p-floatLabel>
                            <p-inputNumber id="confirmedCharges"  [(ngModel)]="medicalBill.totalCharges" mode="currency" currency="USD" locale="en-US"  [disabled]="true" />
                            <label for="confirmedCharges">Total Charges</label>
                        </p-floatLabel>
                    </div>
                    <div class="flex col-1 justify-content-center  mt-2">
                        <i class="pi pi-times"></i>
                    </div>
                    <div *ngIf="locked || !medicalBill.overrideMarkup" class="flex col-3 flex-column  mt-2">
                        <p-floatLabel>
                            <p-inputNumber id="markupPercent"  [(ngModel)]="medicalBill.servicingProviderMarkupPercent" mode="decimal" suffix="%" [maxFractionDigits]="2" [minFractionDigits]="2"  [disabled]="true" />
                            <label for="markupPercent">% of Charges</label>
                        </p-floatLabel>
                    </div>
                    <div *ngIf="medicalBill.overrideMarkup && !locked" class="flex col-3 flex-column mt-2">
                        <p-floatLabel>
                            <p-inputNumber id="manualMarkup"  [(ngModel)]="markupOverrideAmount"  mode="decimal" [maxFractionDigits]="2" [minFractionDigits]="2" suffix="%" (onBlur)="manualMarkupChanged();"  />
                            <label for="manualMarkup">% of Charges</label>
                        </p-floatLabel>
                    </div>
                    <div class="flex col-1 mt-2 ">
                        <i class="pi pi-equals"></i>
                    </div>
                    <div class="flex col-4 mt-2">
                        <p-floatLabel>
                            <p-inputNumber id="payerBilledAmount"  [(ngModel)]="medicalBill.confirmedMarkedUpAmount" mode="currency" currency="USD" locale="en-US"  [disabled]="true" />
                            <label for="payerBilledAmount">Payer Billed</label>
                        </p-floatLabel>
                    </div>
                    <div class="flex col-4"></div>
                    <div class="flex col-3">
                        <p-checkbox *ngIf="!locked" [(ngModel)]="medicalBill.overrideMarkup" binary label="Override" (onChange)="billEdited = true; recalculateMarkedUpAmount();"></p-checkbox>
                    </div>
                    <div class="flex col-5"></div>
                    <div class="flex col-8"></div>
                    <div class="flex col-4">
                        <p-floatLabel>
                            <p-inputNumber id="harloweGain"  [(ngModel)]="medicalBill.gain" mode="currency" currency="USD" locale="en-US"  [disabled]="true" />
                            <label for="harloweGain">Gain</label>
                        </p-floatLabel>
                    </div>


                </div>
                <div class="flex w-full justify-content-center gap-2">
                    <p-button *ngIf="billEdited" icon="pi pi-check" text raised (onClick)="commitDiscountChanges()"></p-button>
                </div>

               
            </div>
        </p-card>
</div>